export default __webpack_public_path__ + "static/media/Background_00094.b6d367ab.png";